export enum DeliveryStatus {
  OutForDelivery = 0,
  Delivered = 1,
  ReadyForPickup = 2,
}
